import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ConnectorService } from '../connector.service';
import { Account } from '../account/account.dto';

@Injectable({
  providedIn: 'root'
})
export class CompteService {
  private compteSubject = new BehaviorSubject<Account | null>(null);
  public compte$ = this.compteSubject.asObservable();

  constructor(
    private http: HttpClient,
    private connector: ConnectorService
  ) {}

  /**
   * Fetch the current user's compte data from the backend
   */
  fetchCompte(): Observable<Account> {
    return this.http.get<Account>(`${environment.backAPI}/compte`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.connector.token()
      }
    }).pipe(
      tap(compte => this.compteSubject.next(compte))
    );
  }

  /**
   * Get the current compte value
   */
  getCurrentCompte(): Account | null {
    return this.compteSubject.value;
  }

  /**
   * Update only the solde_depensable without a full refetch
   */
  updateSolde(solde: number): void {
    const current = this.compteSubject.value;
    if (current) {
      this.compteSubject.next({ ...current, solde_depensable: solde });
    }
  }

  /**
   * Clear the compte data (on logout)
   */
  clearCompte(): void {
    this.compteSubject.next(null);
  }
}
